<template>
  <CollapsableSection
    data-test="climate"
    :title="t('climate_rsk.environmental_and_climate_impact')"
    section-classes="w-full text-xs text-gray-800 border-b border-gray-200 border-solid last:border-0"
    title-classes="lg:text-xl"
    :is-open="isOpen"
    collapsable-padding="px-8 xl:px-12 py-4"
    collapsable-content-classes="px-8 xl:px-12 py-6"
    @update:open="(value) => emit('update:open', value)"
  >
    <div class="flex flex-col w-full gap-2 xl:flex-row">
      <ProductDetailPageClimateLeftSection :climate-r-s-k="climateRSK" :documents="documents" />
    </div>
  </CollapsableSection>
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n';
import { ClimateRSK } from '@/types/products';

type Props = {
  isOpen?: boolean;
  climateRSK?: ClimateRSK;
  documents?: {
    assetUrl: string;
    assetType: string;
    icon: string;
    assetLabel: string;
  }[];
};

const emit = defineEmits<{
  (e: 'update:open', v: boolean): void;
}>();

withDefaults(defineProps<Props>(), {
  isOpen: false,
  climateRSK: () => ({} as ClimateRSK),
  documents: () => [],
});

const { t } = useI18n();
</script>
<script lang="ts">
export default defineComponent({
  name: 'ProductDetailPageClimateSection',
});
</script>
